export function usePrivateApiFetch() {
  return async function fetch<T>(
    url: string,
    options: Parameters<typeof $fetch<T>>[1] = {},
  ) {
    const headers = import.meta.server
      ? useRequestHeaders(["cookie", "authorization"])
      : undefined;

    return await $fetch<T>(url, {
      ...options,
      headers: {
        ...headers,
        ...options?.headers,
      },
    });
  };
}
